import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { Order } from 'src/app/order/models/order.model';
import { ModalService } from 'src/app/core/services/modal.service';
import { OrderService } from 'src/app/order/services/order.service';
import { take, catchError } from 'rxjs/operators';
import { JobService } from 'src/app/timeline-skip/services/job.service';
import { Job } from 'src/app/timeline-skip/models/job.model';
import { TimelineTransportStateService } from '../../services/timeline-transport-state.service';
import { Unit } from 'src/app/order/models/unit.model';

@Component({
    selector: 'app-timeline-transport-order-information',
    templateUrl: './timeline-transport-order-information.component.html',
    styleUrls: ['./timeline-transport-order-information.component.scss'],
    standalone: false
})
export class TimelineTransportOrderInformationComponent implements OnInit,OnChanges {

  @Input()
  order: Order = new Order();
  canDecline: boolean = false;

  @Output()
  closed: EventEmitter<void> = new EventEmitter();

  units: Unit[] = [];

  constructor(private modalService: ModalService,
    private timelineTransportStateService: TimelineTransportStateService,
    private jobService: JobService,
    private orderService: OrderService) { 

    }

  ngOnInit(): void {
    this.timelineTransportStateService.$transportUnitsChanged.subscribe((units: Unit[]) => {
      this.units = units;
    });
  }

  ngOnChanges(simple: SimpleChanges) {
    if(simple.order) {
      if(simple.order.currentValue.id !== -1 && simple.order.currentValue.id) {
        this.jobService.getJobsByOrderId(simple.order.currentValue.id)
        .pipe(take(1))
        .pipe(catchError((e) => {
          if(e.status === 403 || e.status === 401) {
            return e;
          }
          alert('could not get job count');
          return e;
        }))
        .subscribe((jobs: Job[]) => {
          this.canDecline = jobs.length === 0;
        })
      }
    }
  }

  editOrder(orderId: number=-1) {
    this.timelineTransportStateService.$transportOrderIdChanged.next(orderId);
    this.modalService.open('transportTimelineEditOrderModal');
  } 

  close() {
    this.modalService.close('orderTransportInformationModal');
    this.closed.emit();
  }

  getUnitName(unitId: number = -1) {
    let unit = this.units.filter(u => u.id === unitId)[0];

    if(unit) {
      return unit.name;
    } else {
      return '';
    }
  }

}
